import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Footer() {
    return (
        <div className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-6 col-sm-4">
                        <div><b>Official links:</b></div>
                        <a role="button" href="https://t.me/venusprotocol"><FontAwesomeIcon icon="fa-brands fa-telegram" size="2x"/></a>
                        <a role="button" href="https://twitter.com/VenusProtocol"><FontAwesomeIcon icon="fa-brands fa-twitter" size="2x"/></a>
                        <a style={{ color: '#ac2bac' }} role="button" href="https://discord.com/invite/pTQ9EBHYtF">
                            <FontAwesomeIcon icon="fa-brands fa-discord" size="2x"/>
                        </a>
                        <a style={{ color: '#ed302f' }} href="http://www.youtube.com/@venusprotocolofficial" role="button">
                            <FontAwesomeIcon icon="fa-brands fa-youtube" size="2x"/>
                        </a>
                    </div>
                    <div className="col-4 d-none d-lg-block">
                        <div className="text-center">
                            <h5>© Copyright 2023</h5>
                        </div>
                    </div>
                    <div className="col-6 col-sm-4">
                        <div className="text-left">
                            <div><b>Unofficial links:</b></div>
                            <div className="row">
                                <div className="col-3 col-sm-3">
                                    <a role="button" href="https://t.me/venusstats"><FontAwesomeIcon icon="fa-solid fa-chart-simple" size="2x"/></a>
                                    <span className="d-none d-lg-block"><b>Stats</b></span>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <a role="button" href="https://t.me/venuswhaleswatch"><FontAwesomeIcon icon="fa-solid fa-sack-dollar" size="2x"/></a>
                                    <span className="d-none d-lg-block"><b>Whales</b></span>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <a role="button" href="https://t.me/venusliqwatch"><FontAwesomeIcon icon="fa-solid fa-scale-unbalanced-flip" size="2x"/></a>
                                    <span className="d-none d-lg-block"><b>Liquidations</b></span>
                                </div>
                                <div className="col-3 col-sm-3">
                                    <a role="button" href="https://t.me/venus_liq_income"><FontAwesomeIcon icon="fa-solid fa-hand-holding-dollar"size="2x"/></a>
                                    <span className="d-none d-lg-block"><b>Liq.income</b></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;